import React from "react";
import {
  Box,
  Typography,
  Paper,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ContaduriaPublica from "../img/ContaduriaPublica.jpg";

const CarreraContaduria = () => {
  const planEstudios = [
    {
      anio: "PRIMER AÑO",
      materias: [
        "Contabilidad I",
        "Administración I",
        "Introducción a la Economía",
        "Análisis Matemático I",
        "Computación",
        "Realidad Económica de Bolivia",
        "Sociología",
        "Derecho Comercial",
      ],
    },
    {
      anio: "SEGUNDO AÑO",
      materias: [
        "Contabilidad II",
        "Legislación Laboral",
        "Legislación Tributaria",
        "Análisis Matemático II",
        "Estadística I",
        "Microeconomía",
        "Matemática Financiera y Actuarial",
        "Metodología de la Investigación Científica",
      ],
    },
    {
      anio: "TERCER AÑO",
      materias: [
        "Contabilidad Superior",
        "Costos",
        "Estadística II",
        "Contabilidad Bancaria",
        "Sistemas Computarizados Contables",
        "Contabilidad de Cooperativas",
        "Contabilidad Minera",
        "Presupuestos y Balances",
        "Contabilidad Gubernamental",
        "Mercadotecnia I",
      ],
    },
    {
      anio: "CUARTO AÑO",
      materias: [
        "Costos Aplicados",
        "Administración de Costos Industriales",
        "Auditoría Gubernamental y Tributaria",
        "Auditoría",
        "Auditoría Operativa de Gestión",
        "Impuestos",
        "Diseño de Sistemas Contables",
        "Análisis e Interpretación de Estados Financieros",
        "Finanzas",
      ],
    },
    {
      anio: "QUINTO AÑO",
      materias: [
        "Gabinete de Auditoría",
        "Marketing Internacional",
        "Ética Profesional",
        "Auditoría de Sistemas",
        "Finanzas II",
        "Seminario Terminal I",
        "Seminario Terminal II",
      ],
    },
  ];

  const CardSection = ({ title, content, bg = "#f5f5f5" }) => (
    <Paper sx={{ p: 3, mb: 4, backgroundColor: bg, borderRadius: 3 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        {title}
      </Typography>
      {Array.isArray(content) ? (
        content.map((p, i) => (
          <Typography key={i} variant="body1" paragraph>
            {p}
          </Typography>
        ))
      ) : (
        <Typography variant="body1" paragraph>
          {content}
        </Typography>
      )}
    </Paper>
  );

  return (
    <Container maxWidth="ld" sx={{ py: 6, px: 4 }}>
      <Typography
        variant="h4"
        align="center"
        fontWeight="bold"
        color="error"
        gutterBottom
      >
        Carrera de Contaduría Pública - F.C.E.F.A
      </Typography>
      <Box
        sx={{
          width: { xs: "95%", sm: "70%" },
          height: { xs: 220, sm: 400 },
          flexShrink: 0,
          boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
          borderRadius: "8px",
          overflow: "hidden",
          my: 2,
          mx: "auto",
          
        }}
      >
        <img
          src={ContaduriaPublica}
          alt="Contaduría Pública - F.C.E.F.A"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>
      <CardSection
        title="MISIÓN"
        content="Somos una carrera de reconocida calidad y excelencia, que se desempeñen en el ámbito de la información contable, financiera y no financiera, tributaria y de auditoría, con capacidad prospectiva y de liderazgo. Formamos profesionales a nivel técnico superior y de licenciatura, con integridad, calidad y excelencia, altamente competitivos en el mercado profesional, con capacidad para la toma de decisiones, creativos, con espíritu competitivo, emprendedores e innovadores, mentalidad abierta a los cambios y gran responsabilidad social, con actitudes y valores ético morales que los conviertan en agentes de cambio y dinamizadores en el ejercicio de su profesión, para contribuir al desarrollo y progreso de la región y el país."
        bg="#f7d3d3ff"
      />

      <CardSection
        title="VISIÓN"
        content="Ser una Unidad Académica competitiva con prestigio y acreditada a nivel nacional e internacional, formadora de profesionales de alta calidad, excelencia y capacidad reconocida a través de ejecución de programas de grado y posgrado, con perfiles que respondan a las demandas de la sociedad, con amplio dominio de la ciencia y con capacidad de administrar adecuadamente los sistemas de información contable, financiera y no financiera, tributaria y de auditoría, para un correcto posicionamiento y la toma de decisiones, con un modelo académico centrado en el estudiante dentro una enseñanza integradora, a través de un proceso planificado y sistematizado con pertinencia."
        bg="#c7e0f8ff"
      />

      <CardSection
        title="PERFIL PROFESIONAL"
        content="El profesional en Contaduría Pública gestiona, analiza y evalúa procesos contables, financieros, de auditoría, costos y tributación en entidades públicas y privadas, proporcionando información veraz para la toma de decisiones. Administra recursos financieros con eficiencia y ética, ejecuta auditorías para garantizar transparencia y cumplimiento normativo, diseña sistemas contables para apoyar la gestión institucional, e interpreta la normativa tributaria vigente para asegurar el cumplimiento fiscal, actuando siempre con responsabilidad, objetividad y adaptación a los cambios del entorno."
        bg="#f8e2ffff"
      />

      <CardSection
        title="OBJETIVOS"
        content={[
          "Formar profesionales idóneos, con conciencia crítica y creativa, de reconocida calidad y excelencia, con alto grado ético moral en el desempeño de sus actividades profesionales, capaces de preservar e incorporar compatiblemente las innovaciones científicas y tecnológicas del país y el mundo.",
          "Formar profesionales competentes y con pertinencia en el ámbito de la ciencia contable con alta responsabilidad social, que respondan a las necesidades del desarrollo regional y nacional, con capacidad para resolver problemas relacionados con la contabilidad, auditoría, finanzas y asesoramiento gerencial; utilizando para ello métodos, técnicas y procedimientos cuantitativos y cualitativos.",
        ]}
        bg="#fbfde3ff"
      />

      {/* PLAN DE ESTUDIOS */}
      <Typography
        variant="h5"
        align="center"
        fontWeight="bold"
        color="primary"
        gutterBottom
      >
        Plan de Estudios - Nivel Licenciatura
      </Typography>

      {planEstudios.map((anio, index) => (
        <Accordion key={index} sx={{ mb: 2 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight="bold">{anio.anio}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack direction="row" flexWrap="wrap" gap={1}>
              {anio.materias.map((materia, idx) => (
                <Chip
                  key={idx}
                  label={materia}
                  variant="outlined"
                  color="primary"
                />
              ))}
            </Stack>
          </AccordionDetails>
        </Accordion>
      ))}

      {/* ASPECTOS ACADÉMICOS */}
      <Box>
        <Paper
          sx={{
            p: { xs: 3, sm: 2, md: 4 },
            backgroundColor: "#fef8d0ff",
            borderRadius: 3,
            mb: 4,
          }}
        >
          <Typography
            variant="h5"
            align="center"
            fontWeight={600}
            color="primary"
            gutterBottom
          >
            ASPECTOS ACADÉMICOS
          </Typography>
          <Typography variant="body1" align="left" mb={2}>
            <strong>Modalidades de Ingreso:</strong> Cursos
            Pre-Universitarios, Examen de Ingreso.
          </Typography>
          <Typography variant="body1" align="left" mb={2}>
            <strong>Tiempo de Estudios:</strong> Cinco años turno
            diurno Cinco años y medio turno vespertino.
          </Typography>
          <Typography variant="body1" align="left" mb={2}>
            <strong>Diploma Académico:</strong> Licenciado en
            Contaduría Pública.
          </Typography>
          <Typography variant="body1" align="left" mb={2}>
            <strong>Título en Provisión Nacional de:</strong> Contador
            Público.
          </Typography>
          <Typography variant="body1" align="left" mb={2}>
            <strong>Modalidades de Graduación:</strong> Examen de
            Grado, Tesis Libre, Tesis Dirigida."
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default CarreraContaduria;
